
/**
 * 好分期
 * @param productId
 * @returns
 */
const HAOFENQI_COMMODITY = '8214';

/**
 * 导流-星粒花
 */
const XINGLIHUA_COMMODITY = '8207';

/**
 * 盛银-明华东
 */
const SHENGYIN_COMMODITY = '8206';

/**
 * 国美渠道
 */
const GUOMEI_NEW_COMMODITY = '8115';

/*
 * 拍拍贷重新对接渠道 id
 */
const PPD_NEW_COMMODITY = '8116';


/**
 * 阳光消金
 */
const YANGGUANG_COMMODITY = '8114';

/**
 * 众安小贷
 */
const ZHONGAN_LOAN = '8113';

/**
 * 富民银行
 */
const FUMINBANK = '8112';

/**
 * 苏银消金
 */
const SUYINXIAOJIN = '8111';

/**
 * 信用飞
 */
const XINYONGFEI = '8110';

/**
 * 自营 B 锦程消金
 */
const AUTARKY_B_COMMODITY = '8180';

/**
 * 恒小花
 */
const HENGXIAOHUA = '8100';

/**
 * 苏宁银行--江苏苏宁银行-升级贷
 */
const SUNINGBANK_COMMODITY = '8090';

/**
 * 小赢卡贷-循环额度
 */
const XIAOYINGKAYI_REPEAT_COMMODITY = '7501';

/**
 * 中原联营
 */
const ZHONGYUAN_UNION_COMMODITY = '2095';

/**
 * 锡商银行
 */
const XISHANGBANK_COMMODITY = '8080';

/**
 * 携程金融
 */
const XIECHENGFIN_COMMODITY = '8050';

/**
 * 百信银行(自营渠道)
 */
const BAIXINBANK_COMMODITY = '8070';

/**
 * 洋钱罐
 */
const YANGQIANGUAN_COMMODITY = '8060';

/**
 * 亿联银行
 */
const YILIANBANK_COMMODITY = '8040';

/**
 * 豆豆钱
 */
const DOUDOUQIAN_COMMODITY = '8030';

/**
 * 欢太花钱
 */
export const HUANTAIHUAQIAN_COMMODITY = '8020';

/**
 * 唯品消金
 */
export const WEIPINXIAOJIN_COMMODITY = '8010';

/**
 * 百融还呗
 */
export const BAIRONGHUANBEI_COMMODITY = '8000';

/** 我来数科渠道
 */
export const WOLAISHUKE_COMMODITY = '7900';

/**
 * 小花钱包
 */
export const XIAOHUAQIANBAO_COMMODITY = '7700';

/**
 * 富行贷渠道
 */
export const FUJINFU_COMMODITY = '7800';
/**
 * 中银渠道
 */
export const ZHONGYIN_COMMODITY = '7600';

/**
 * 小赢卡贷-单笔单批
 */
export const XIAOYINGKAYI_COMMODITY = '7500';

/**
 * 小象
 */
export const XIAOXIANG_COMMODITY = '7400';


/**
 * 智度小贷
 */
export const ZHIDUXIAODAI_COMMODITY = '7300';

/**
 * 度小满
 */
export const DUXIAOMAN_COMMODITY = '7200';


/**
 * 新桔子
 */
export const NEWORAGE_COMMODITY = '6070';

/**
 * 天美贷-崇天小贷
 */
export const CHONGTIANMEIDAI_COMMODITY = '6060';


/** *
 *
 * 支付宝环境下的银河
 * */
export const ALIPAYMINI_COMMODITY = '5060';


/** *
 * 中邮渠道
 * */
export const ZHONGYOU_COMMODITY = '7100';

/** *
 * TCL金融
 * */
export const TCL_COMMODITY = '5110';
/**
 * 甜橙借钱
 * */
export const TIANCHENG_COMMODITY = '5050';

/**
 * 民生
 * */
export const MINSHENG_COMMODITY = '6600';


/**
 * 万达
 */
export const WANDA_COMMODITY = '5210';

/**
 * 国美
 */
export const GUOMEI_COMMODITY = '6800';
/**
 * 百融天美
 */
export const TIANMEI_COMMODITY = '5100';

/**
 * 新银河渠道
 */

export const NEW_YINHE_COMMODITY = '4060';

/**
 * 银河渠道  该渠道已下线，后续重构代码时应去除该代码逻辑的特殊处理（还款流程需确认是否可以去除，存在老赖用户）
 * @param productId
 */
export const YINHE_COMMODITY = '6000';

/**
 * 宜享花
 * @param productId
 */
export const YXH_COMMODITY = '5800';

/**
 * 百信
 * @param productId
 */
export const BAIXIN_COMMODITY = '4050';

/**
 * 尧信
 * @param productId
 */
export const YAOXIN_COMMODITY = '5200';

/**
 * 还呗
 * @param productId
 */
export const HUANBEI_COMMODITY = '4040';

/**
 * 时光分期
 * @param productId
 */
export const SHIGUANGFENQI_COMMODITY = '4090';

/**
 * 小花钱包
 * @param productId
 */
export const XIAOHUA_COMMODITY = '4020';

/**
 * 锦程消金
 * @param productId
 */
export const JINCHENG_COMMODITY = '4010';

/**
 * 同程
 * @param productId
 */
export const TONGCHENG_COMMODITY = '5000';

/**
 * 量化派
 * @param productId
 */
export const LHUAPAI_COMMODITY = '4000';

/**
 * 微博
 * @param productId
 */
export const WEIBO_COMMODITY = '3900';

/**
 * 湖消
 * @param productId
 */
export const HUXIAO_COMMODITY = '3800';

/**
 * 橘子分期
 * @param productId
 */
export const JUZI_COMMODITY = '3700';

/**
 * 拍拍贷
 * @param productId
 */
export const PPD_COMMODITY = '3600';

/**
 * 新流
 * @param productId
 */
export const XL_COMMODITY = '3500';

/**
 * 省呗
 * @param productId
 * 已下线
 */
export const SHENGBEI_COMMODITY = '3400';

/**
 * 苏宁金融任性贷
 * @param productId
 */
export const SUNING_COMMODITY = '3300';

/**
 * 分期乐
 * @param productId
 */
export const FENQILE_COMMODITY = '3200';

/**
 * 极融
 * @param productId
 */
export const JR_COMMODITY = '3100';

/**
 * 51信用卡
 * @param productId
 */
export const CREDITCARD_COMMODITY = '5200';

/**
 * 360
 * @param productId
 */
export const SANLIULING_COMMODITY = '3000';

/**
 * 中原
 * @param productId
 */
export const ZHONGYUAN_COMMODITY = '2090';

/**
 * 马上
 * @param productId
 * 已下线
 */
export const MASHANG_COMMODITY = '2080';

/**
 * 趣店
 * @param productId
 */
export const QUDIAN_COMMODITY = '2060';

/**
 * 小米
 * @param productId
 */
export const XIAOMI_COMMODITY = '2070';

/**
 * 杭银
 * @param productId
 */
export const HANGYIN_COMMODITY = '2050';

/**
 * 老杭银
 * @param productId
 */
export const HANGYINOLD_COMMODITY = '2040';

/**
 * 蒙商渠道
 * @param productId
 * @returns
 */
export const MENGSHANG_COMMODITY = '4070';

/**
 * 车主贷
 * @param productId
 * @returns
 */
export const CHEZHUDAI_COMMODITY = '4080';

/**
 * 招集令
 * @param productId
 * @returns
 */
export const ZHAOJILING_COMMODITY = '8221';

/**
 * 众易贷（众邦银行）
 * @param productId
 * @returns
 */
export const ZHONGYIDAI_COMMODITY = '8223';

/**
 * 你我贷蓝海
 * @param productId
 * @returns
 */
export const NIWODAI_LANHAI_COMMODITY = '8226';

/**
 * 桔子唯品
 */
export const JUZI_WEIPIN_COMMODITY = '8229';

/**
 * 富邦华一
 */
export const FUBANGHUAYI_COMMODITY = '8239';

/**
 * 新银河渠道判断
 */
export const isNewYhChannel = (productId: string | undefined): boolean => {
  const commodity = productId as string;
  return [NEW_YINHE_COMMODITY, ALIPAYMINI_COMMODITY].indexOf(commodity) >= 0;
};

const ProductCommodity = {
  DOUDOUQIAN_COMMODITY,
  YILIANBANK_COMMODITY,
  YANGQIANGUAN_COMMODITY,
  BAIXINBANK_COMMODITY,
  XIECHENGFIN_COMMODITY,
  XISHANGBANK_COMMODITY,
  XIAOYINGKAYI_REPEAT_COMMODITY,
  HENGXIAOHUA,
  SUNINGBANK_COMMODITY,
  XINYONGFEI,
  AUTARKY_B_COMMODITY,
  ZHONGYUAN_UNION_COMMODITY,
  SUYINXIAOJIN,
  FUMINBANK,
  ZHONGAN_LOAN,
  YANGGUANG_COMMODITY,
  GUOMEI_NEW_COMMODITY,
  PPD_NEW_COMMODITY,
  SHENGYIN_COMMODITY,
  XINGLIHUA_COMMODITY,
  HAOFENQI_COMMODITY,
  ZHAOJILING_COMMODITY,
  ZHONGYIDAI_COMMODITY,
  NIWODAI_LANHAI_COMMODITY,
  JUZI_WEIPIN_COMMODITY,
  FUBANGHUAYI_COMMODITY,
};

export default ProductCommodity;
